import React from 'react';
import { Field, useField } from 'formik';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import Asterisk from '../Asterisk/index';
import TooltipInfo from '../TooltipInfo/TooltipInfo';
import { H5, LabelSmall, LinkText, LinkTextDisabled } from '@styled';

const CheckboxGroup = ({ label, ...props }) => {
    const [field, meta] = useField(props);
    const { name, options, required, instructions } = props;

    const hasError = meta.touched && meta.error;
    const groupClasses = classnames('form-group');

    return (
        <div className={groupClasses}>
            <div>
                {label && (
                    <H5 className="mb-0.5rem">
                        {label} {required && <Asterisk />}
                    </H5>
                )}

                {instructions && (
                    <div className="mb-0.5rem">
                        <LabelSmall>{instructions}</LabelSmall>
                    </div>
                )}
            </div>

            {options.map((option, i) => (
                <div className="form-check" key={`checkbox-${props.name}-${i}`}>
                    <label className="d-flex form-check-label">
                        <Field
                            className="form-check-input mr-0.5rem"
                            type="checkbox"
                            name={props.name}
                            value={option.value}
                            disabled={option.disabled}
                        />
                        {option.disabled ? (
                            <LinkTextDisabled>{option.label}</LinkTextDisabled>
                        ) : (
                            <LinkText>{option.label}</LinkText>
                        )}

                        {option.tooltip && (
                            <div className="d-inline-block ml-0.25rem">
                                <TooltipInfo text={option.tooltip} />
                            </div>
                        )}
                    </label>
                </div>
            ))}

            {hasError ? <div className="error-msg">{meta.error}</div> : null}
        </div>
    );
};

CheckboxGroup.propTypes = {
    label: PropTypes.string,
    name: PropTypes.string,
    options: PropTypes.array.isRequired,
    required: PropTypes.bool,
    instructions: PropTypes.string,
};

export default CheckboxGroup;
